import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { UserPermissionKind } from '@skylab-shared/dataModel';

export interface UserRole {
    readonly id: number;
    readonly name: string;
    readonly permissionKinds: UserPermissionKind[];
}

export class UserRoleQuery extends Query<UserRole[]> { }

export class UserRoleQueryHandlerBase implements QueryHandler<UserRoleQuery, UserRole[]> {
    public static Url = TaggedUrl.join('user/role', [Tags.Api]);

    public constructor(private readonly $http: HttpService) { }

    public async handleAsync(_: UserRoleQuery): Promise<UserRole[]> {
        const { data } = await this.$http.get<UserRole[]>(UserRoleQueryHandlerBase.Url);
        return data;
    }
}
